import { List } from 'lucide-react';
import { z } from 'zod';
import { ListFieldInput, ListFieldView } from '../renderers/fields/list/list-field';
import type { FieldDefinition, ListFieldSchema } from '../types';

export const ListDefinition: FieldDefinition<ListFieldSchema, string[] | null | undefined> = {
  type: 'list',
  toolboxLabel: 'Option List',
  category: 'Selection',
  description: 'An editable list of text items, perfect for defining selection options.',
  icon: List,

  createDefault: (id) => ({
    id,
    type: 'list',
    name: `list_${id}`,
    label: 'Items',
    required: false,
    itemPlaceholder: 'New option...',
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
    { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
    {
      id: 'itemPlaceholder',
      type: 'text',
      name: 'itemPlaceholder',
      label: 'Item Placeholder',
      required: false,
    },
    {
      id: 'required',
      type: 'checkbox',
      name: 'required',
      label: 'Required List',
      required: false,
    },
  ],

  buildValidation: (field) => {
    let schema = z.array(z.string());

    if (field.required) {
      schema = schema.min(1, `${field.label} must have at least one item`);
    }

    return schema.optional().nullable();
  },

  editComponent: ListFieldInput,
  viewComponent: ListFieldView,
};
